import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { ErrorBoundary } from './components/ErrorBoundary'

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('react-root')
  if (rootElement) {
    const root = createRoot(rootElement)
    root.render(
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    )
  }
})

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[PWA] Service worker registered:', registration)

        registration.addEventListener('updatefound', () => {
          console.log('[PWA] Service worker update found')
        })
      })
      .catch((error) => {
        console.error('[PWA] Service worker registration failed:', error)
      })
  })
}
